import { useQuery } from '@tanstack/react-query';
import { getAutomationGuide, type AutomationGuideType } from '@/services/automationGuide.service';

/** 자동화 설명서 조회. 다이얼로그가 열릴 때만 fetch, 404는 재시도 안 함. */
export const useAutomationGuide = (type: AutomationGuideType | null, enabled: boolean) =>
    useQuery({
        queryKey: ['automation-guide', type],
        queryFn: () => getAutomationGuide(type as AutomationGuideType),
        enabled: enabled && !!type,
        retry: false,
        staleTime: 10 * 60 * 1000,
    });
